<div>
  <div class="bg-custom">
    <div class="container">
      <section>
        <div>
          <nh-alert type="success" [isOpen]="showChangeReqSuccessAlert">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span>{{ "MCOCHANGE_REQUESTED" | globalTranslate }}</span>
              </div>
            </div>
          </nh-alert>
          @if (caseNumberList.length >1) {
          <div>
            <h1 class="section-header">
              {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT1" | globalTranslate }}
            </h1>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <span
                  ><strong>{{
                    "COVERAGE_CASE_NUMBER" | globalTranslate
                  }}</strong></span
                >:
              </div>
              <div class="col-md-4">
                @if (translatedLang === 'en') {
                <select
                  class="custom-select-info"
                  aria-label="caseNumber"
                  [(ngModel)]="caseNumber"
                  (change)="changecaseNumber()"
                >
                  <option [ngValue]="null">
                    {{ "PICK_AN_OPTION" | globalTranslate }}
                  </option>
                  @for (option of caseNumberList; track option) {
                  <option [ngValue]="option">{{ option }}</option>
                  }
                </select>
                } @if (translatedLang !== 'en') {
                <select
                  class="custom-select-info"
                  aria-label="Número de Caso"
                  [(ngModel)]="caseNumber"
                  (change)="changecaseNumber()"
                >
                  <option [ngValue]="null">
                    {{ "PICK_AN_OPTION" | globalTranslate }}
                  </option>
                  @for (option of caseNumberList; track option) {
                  <option [ngValue]="option">{{ option }}</option>
                  }
                </select>
                }
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary"
                  (click)="submitCaseNumber()"
                  [disabled]="disableSubmit"
                >
                  {{ "SELECT" | globalTranslate }}
                </button>
              </div>
            </div>
            <br />
          </div>
          } @if (showHealthPlanInfoSectionTable && changePlanRows.length==0 &&
          caseNumberList1.length == 1) {
          <div>
            <h1 class="section-header">
              {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT2" | globalTranslate }}
            </h1>
            <hr />
            <p style="font-size: 15px">
              {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT8" | globalTranslate }}
              <span style="color: #174a7c">1-855-259-0701</span>
              {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT9" | globalTranslate }}
            </p>
          </div>
          } @if (showHealthPlanInfoSectionTable && changePlanRows &&
          changePlanRows.length) {
          <div>
            <h2 class="section-header">
              {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT2" | globalTranslate }}
            </h2>
            <hr />
            <p>{{ "HEALTH_PLAN_DETAILS_STATIC_TEXT3" | globalTranslate }}</p>
            <div class="d-none d-lg-block">
              @if (!isMobileView) {
              <ngx-datatable
                class="bootstrap striped"
                #table
                [rows]="changePlanRows"
                [columnMode]="'force'"
                [headerHeight]="'auto'"
                [footerHeight]="50"
                [rowHeight]="'auto'"
              >
                <ngx-datatable-column
                  [name]="changePlanColumns[0].name | globalTranslate"
                  [prop]="changePlanColumns[0].prop"
                >
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[1].name | globalTranslate"
                  [prop]="changePlanColumns[1].prop"
                >
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[2].name | globalTranslate"
                  [prop]="changePlanColumns[2].prop"
                >
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[3].name | globalTranslate"
                  [prop]="changePlanColumns[3].prop"
                >
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[4].name | globalTranslate"
                >
                  <ng-template ngx-datatable-cell-template let-row="row">
                    {{
                      row.endDate === "N/A"
                        ? ("N/A" | globalTranslate)
                        : row.endDate
                    }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[5].name | globalTranslate"
                >
                  <ng-template ngx-datatable-cell-template let-row="row">
                    {{
                      row.futureProviderName === "N/A"
                        ? ("N/A" | globalTranslate)
                        : row.futureProviderName
                    }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  [name]="changePlanColumns[6].name | globalTranslate"
                >
                  <ng-template ngx-datatable-cell-template let-row="row">
                    {{
                      row.futurestartDate === "N/A"
                        ? ("N/A" | globalTranslate)
                        : row.futurestartDate
                    }}
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              }
            </div>
            <div class="nh-table-mobile d-lg-none">
              @for (row of changePlanRows; track row) {
              <div class="table-row mb-3 pb-3">
                <div class="mobile-table-header">
                  {{ changePlanColumns[0].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">{{ row.member }}</div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[1].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">{{ row.caseNumber }}</div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[2].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">{{ row.providerName }}</div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[3].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">{{ row.startDate }}</div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[4].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">
                  {{
                    row.endDate === "N/A"
                      ? ("N/A" | globalTranslate)
                      : row.endDate
                  }}
                </div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[5].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">
                  {{
                    row.futureProviderName === "N/A"
                      ? ("N/A" | globalTranslate)
                      : row.futureProviderName
                  }}
                </div>
                <br />
                <div class="mobile-table-header">
                  {{ changePlanColumns[6].name | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">
                  {{
                    row.futurestartDate === "N/A"
                      ? ("N/A" | globalTranslate)
                      : row.futurestartDate
                  }}
                </div>
                <br />
              </div>
              }
            </div>
          </div>
          } @if (showHealthPlanMcoSection && changePlanRows &&
          changePlanRows.length && hideHealthPlanOptions &&
          !submitMcoNewChangeSw && isHoh) {
          <div class="row mt-2">
            <!-- commented the code for future use
                                                <div *ngIf="membersNotEligible.length > 0 && hoHSW === 'Y'" class="pt-2 pb-2 col-md-12">
                                                  <p [innerHTML]="'HEALTH_PLAN_DETAILS_STATIC_TEXT5_1' | globalTranslate: {notEligibleUsers: membersNotEligibleString }" style="margin:0;font-size: 15px;"></p>
                                                </div> -->
            <div class="col-md-7">
              <label for="healthPlanMCO" class="label-section">{{
                "HEALTH_PLAN_DETAILS_STATIC_TEXT4" | globalTranslate
              }}</label>
              @if (translatedLang === 'en') {
              <select
                class="custom-select-info"
                aria-label="healthPlan options"
                [(ngModel)]="healthPlanMCO"
                (change)="changeMCO()"
              >
                <option [ngValue]="null">
                  {{ "PICK_AN_OPTION" | globalTranslate }}
                </option>
                @for (option of healthPlanMCOoptions; track option) {
                <option [ngValue]="option">
                  {{ option.enDescription }}
                </option>
                }
              </select>
              } @if (translatedLang !== 'en') {
              <select
                class="custom-select-info"
                aria-label="opciones de planes de salud"
                [(ngModel)]="healthPlanMCO"
                (change)="changeMCO()"
              >
                <option [ngValue]="null">
                  {{ "PICK_AN_OPTION" | globalTranslate }}
                </option>
                @for (option of healthPlanMCOoptions; track option) {
                <option [ngValue]="option">
                  {{ option.spDescription }}
                </option>
                }
              </select>
              }
            </div>
            <div col="col-md-5" style="margin-top: 12px">
              <button
                (click)="openHealthPlansModal()"
                class="btn healthplan-more-info"
                [ngClass]="{
                  'width-translate': increaseWidth(),
                  'font-translate': decreaseFont()
                }"
              >
                {{ "MOREINFO_BUTTON_TEXT" | globalTranslate }}
              </button>
              @if (showSubmit) {
              <button
                class="btn btn-secondary"
                style="height: 55px"
                [disabled]="disableMCOSubmit"
                (click)="submitMCOChange()"
              >
                {{ "SUBMIT" | globalTranslate }}
              </button>
              }
            </div>
          </div>
          } @if (changePlanRows.length) {
          <div>
            @if (notEligibleText || notDisplaySubmitText) {
            <div class="pt-2 pb-2">
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT6_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT6' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
            } @if (priorCaseSubmitted && mcoRequestYear && errorStatus !==
            'ERROR' && !isHoh && submitMcoNewChangeSw) {
            <div>
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT5_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT5' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
            } @if (priorCaseSubmitted && mcoRequestYear && errorStatus !==
            'ERROR' && !submitMcoNewChangeSw) {
            <div>
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT5_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT5' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
            }
          </div>
          } @if (changePlanRows.length && (errorStatus === 'ERROR' &&
          !mcoRequestYear && !eligibleCase) && submitMcoNewChangeSw && errorCode
          !== '1') {
          <div>
            <div class="pt-2 pb-2">
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT10_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT10' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
          </div>
          } @if (changePlanRows.length && errorCode === '1' &&
          submitMcoNewChangeSw) {
          <div>
            <div class="pt-2 pb-2">
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT12_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT12' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
          </div>
          } @if (changePlanRows.length && errorStatus === 'ERROR' &&
          !mcoRequestYear && !submitMcoNewChangeSw) {
          <div>
            <div class="pt-2 pb-2">
              @if (isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT10_mobile' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              } @if (!isMobileView) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT10' | globalTranslate
                "
                style="margin: 0; font-size: 15px"
              ></p>
              }
            </div>
          </div>
          }
          <div></div>
          <!-- <div *ngIf="changePlanRows.length && isCaseApprovedStatus === false">
                                            <div class="pt-2 pb-2">
                                              <p [innerHTML]="'HEALTH_PLAN_DETAILS_STATIC_TEXT6' | globalTranslate" style="margin:0;font-size: 15px;"></p>
                                            </div>
                                          </div> -->
          @if (showMcoSummaryHistory) {
          <div>
            @if (changePlanRows && changePlanRows.length && changeReqSummayRows
            && changeReqSummayRows.length) {
            <div>
              <h2 class="section-header">
                {{ "HEALTH_PLAN_DETAILS_STATIC_TEXT7" | globalTranslate }}
              </h2>
              <hr />
              @if (isHoh && submitMcoNewChangeSw) {
              <p
                [innerHTML]="
                  'HEALTH_PLAN_DETAILS_STATIC_TEXT11' | globalTranslate
                "
              ></p>
              }
              <div class="d-none d-lg-block">
                @if (!isMobileView) {
                <ngx-datatable
                  class="bootstrap striped"
                  #table
                  [rows]="changeReqSummayRows"
                  [columnMode]="'force'"
                  [headerHeight]="'auto'"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                >
                  <ngx-datatable-column
                    [name]="changeReqSummayColumns[0].name | globalTranslate"
                    [prop]="changeReqSummayColumns[0].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="changeReqSummayColumns[1].name | globalTranslate"
                    [prop]="changeReqSummayColumns[1].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="changeReqSummayColumns[2].name | globalTranslate"
                    [prop]="changeReqSummayColumns[2].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="changeReqSummayColumns[3].name | globalTranslate"
                    [prop]="changeReqSummayColumns[3].prop"
                  >
                  </ngx-datatable-column>
                  <ngx-datatable-column
                    [name]="changeReqSummayColumns[4].name | globalTranslate"
                  >
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.status | globalTranslate }}
                    </ng-template>
                  </ngx-datatable-column>
                  @if (isHoh && submitMcoNewChangeSw) {
                  <ngx-datatable-column name="{{ 'Action' | globalTranslate }}">
                    <ng-template
                      ngx-datatable-cell-template
                      let-row="row"
                      let-rowIndex="rowIndex"
                    >
                      @if (row?.cancelSw === 'Y') {
                      <button
                        class="btn d-grid btn-outline-secondary"
                        [ngClass]="{
                          'width-cancel-trans': increaseWidthCancel()
                        }"
                        (click)="cancelHealthPlan(row)"
                      >
                        {{ "CANCEL" | globalTranslate }}
                      </button>
                      }
                    </ng-template>
                  </ngx-datatable-column>
                  }
                </ngx-datatable>
                }
              </div>
              <div class="nh-table-mobile d-lg-none">
                @for (row of changeReqSummayRows; track row) {
                <div class="table-row mb-3 pb-3">
                  <div class="mobile-table-header">
                    {{ changeReqSummayColumns[0].name | globalTranslate }}
                  </div>
                  <hr />
                  <div class="mobile-table-data">{{ row.requestedBy }}</div>
                  <br />
                  <div class="mobile-table-header">
                    {{ changeReqSummayColumns[1].name | globalTranslate }}
                  </div>
                  <hr />
                  <div class="mobile-table-data">
                    {{ row.currentHealthPlan }}
                  </div>
                  <br />
                  <div class="mobile-table-header">
                    {{ changeReqSummayColumns[2].name | globalTranslate }}
                  </div>
                  <hr />
                  <div class="mobile-table-data">{{ row.newHealthPlan }}</div>
                  <br />
                  <div class="mobile-table-header">
                    {{ changeReqSummayColumns[3].name | globalTranslate }}
                  </div>
                  <hr />
                  <div class="mobile-table-data">{{ row.requestDate }}</div>
                  <br />
                  <div class="mobile-table-header">
                    {{ changeReqSummayColumns[4].name | globalTranslate }}
                  </div>
                  <hr />
                  <div class="mobile-table-data">
                    {{ row.status | globalTranslate }}
                  </div>
                  <br />
                  @if (isHoh && submitMcoNewChangeSw) {
                  <div class="mobile-table-header">
                    {{ "Action" | globalTranslate }}
                  </div>
                  }
                  <hr />
                  @if (row.cancelSw === 'Y' && isHoh && submitMcoNewChangeSw) {
                  <div
                    class="mobile-table-data"
                    (click)="cancelHealthPlan(row)"
                  >
                    <button
                      class="btn d-grid btn-outline-secondary"
                      (click)="cancelHealthPlan(row)"
                    >
                      {{ "CANCEL" | globalTranslate }}
                    </button>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
          } @if (showHealthPlanMcoSection && showSubmit && changePlanRows &&
          changePlanRows.length && submitMcoNewChangeSw && isHoh) {
          <div class="row mt-2">
            <!-- commented the code for future use
                                                                      <div *ngIf="membersNotEligible.length > 0 && hoHSW === 'Y'" class="pt-2 pb-2 col-md-12">
                                                                        <p [innerHTML]="'HEALTH_PLAN_DETAILS_STATIC_TEXT5_1' | globalTranslate: {notEligibleUsers: membersNotEligibleString }" style="margin:0;font-size: 15px;"></p>
                                                                      </div> -->
            <div class="col-md-7">
              <label for="healthPlanMCO" class="label-section">{{
                "HEALTH_PLAN_DETAILS_STATIC_TEXT4" | globalTranslate
              }}</label>
              @if (translatedLang === 'en') {
              <select
                class="custom-select-info"
                aria-label="healthPlan options"
                [(ngModel)]="healthPlanMCO"
                (change)="changeMCO()"
              >
                <option [ngValue]="null">
                  {{ "PICK_AN_OPTION" | globalTranslate }}
                </option>
                @for (option of healthPlanMCOoptions; track option) {
                <option [ngValue]="option">
                  {{ option.enDescription }}
                </option>
                }
              </select>
              } @if (translatedLang !== 'en') {
              <select
                class="custom-select-info"
                aria-label="opciones de planes de salud"
                [(ngModel)]="healthPlanMCO"
                (change)="changeMCO()"
              >
                <option [ngValue]="null">
                  {{ "PICK_AN_OPTION" | globalTranslate }}
                </option>
                @for (option of healthPlanMCOoptions; track option) {
                <option [ngValue]="option">
                  {{ option.spDescription }}
                </option>
                }
              </select>
              }
            </div>
            <div col="col-md-5" style="margin-top: 12px">
              <button
                (click)="openHealthPlansModal()"
                class="btn healthplan-more-info"
                [ngClass]="{
                  'width-translate': increaseWidth(),
                  'font-translate': decreaseFont()
                }"
              >
                {{ "MOREINFO_BUTTON_TEXT" | globalTranslate }}
              </button>
              @if (showSubmit) {
              <button
                class="btn btn-secondary"
                style="height: 55px"
                [disabled]="disableMCOSubmit"
                (click)="submitMCOChange()"
              >
                {{ "SUBMIT" | globalTranslate }}
              </button>
              }
            </div>
          </div>
          }
        </div>
      </section>
    </div>
  </div>
</div>